<ng-container *ngIf="tripMessage$ | async as message">
  <fin-section-review [title]="message.teaserTitle" [noButton]="true">
    <ng-container ngProjectAs="content">
      <div class="wrapper flex flex--row">
        <div class="content-description" [innerHTML]="message.teaserText | finSafe: 'html'"></div>
        <div class="content-icon">
          <fcom-icon [name]="message.localSettings?.iconName" class="icon-xxlarge nordic-blue-900-text" />
        </div>
      </div>
    </ng-container>
  </fin-section-review>
</ng-container>
